import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import GLEntityForm from "./GLEntityForm";
import AddButton from "../../../../components/AddButton";

import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useGLEntity from "./hooks/useGLEntity";
import useDeleteGLEntity from "./hooks/useDeleteGLEntity";
import useUpdateGLEntity from "./hooks/useUpdateGLEntity";
import {
  addStateGLEntity,
  selectedRowsStateGLEntity,
  setFilterTextGLEntity,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { useQueryClient } from "react-query";
import MaterialOfficeConfigTable from "../../../../components/tables/MaterialOfficeConfigTable";

const GLEntityTable = () => {
  //Hooks Call
  const { data, isFetching } = useGLEntity();
  const [glEntyFilteredData, setGlEntyFilteredData] = useState([]);
  const { mutateAsync: UpdateGLEntity } = useUpdateGLEntity();
  const BulkDeleteGLEntity = useDeleteGLEntity();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateGLEntity);
  const [filterText, setFilterText] = useRecoilState(setFilterTextGLEntity);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateGLEntity
  );
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const [, setEdit] = useState(false);
  const queryClient = useQueryClient();

  const addPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_glentity_add;
  const editPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_glentity_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_officeconfiguration_glentity_delete;

  const userPermissions = useRecoilValue(permissionsSelector);
  const defaultValues = {
    glentityId: 0,
    glentityName: "",
    isActive: 0,
    modifiedBy: "",
    modifiedDate: null,
    glnumber: "",
    createdDate: null,
    createdBy: "",
  };
  const [empNewData, setNewData] = useState([defaultValues]);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setGlEntyFilteredData(result);
          setGLId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);
  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const [editRowData, setEditRowData] = useState([]);
  const [error, setError] = useState("");

  const validateGLNumber = (
    glnumber,
    glentityName,
    setError,
    setEmpTypeDataIsChange
  ) => {
    const num = Number(glnumber);

    if (num >= 10000 && num <= 29999) {
      setError("Value must be between 1-9999 or 30000 above.");
      setEmpTypeDataIsChange(false);
      return false;
    } else if (glnumber && glentityName) {
      setEmpTypeDataIsChange(true);
      setError("");
      return true;
    }

    setError("");
    setEmpTypeDataIsChange(true);
    return true;
  };

  const handleCheckBox = (checked) => {
    const { glentityName, glnumber, isActive } = empNewData[0];

    // If unchanged and empty fields, mark as unchanged
    if (!glentityName && !glnumber && !isActive === editRowData.isActive) {
      setEmpTypeDataIsChange(false);
    } else {
      validateGLNumber(glnumber, glnumber, setError, setEmpTypeDataIsChange);
    }

    // Update checkbox state
    setCheckStatus(checked);

    // Update isActive
    setNewData(empNewData.map((x) => ({ ...x, isActive: checked })));
  };

  const handleEditFieldsChange = (sourceType, fieldName, row, inputvalue) => {
    const trimmedValue = inputvalue.trim();

    if (sourceType !== "GLEntityType") return;

    // Update all items immutably
    const updatedData = empNewData.map((x) => ({
      ...x,
      [fieldName]: trimmedValue,
    }));
    setNewData(updatedData);

    const { glentityName, glnumber } = updatedData[0];

    // Check if duplicate exists
    const duplicate = data.some(
      (item) =>
        item.glentityName.toUpperCase() === glentityName.toUpperCase() &&
        item.glnumber === Number(glnumber)
    );

    if (duplicate) {
      setEmpTypeIsExistState(false);
      setEmpTypeDataIsChange(false);
      return;
    }

    setEmpTypeIsExistState(true);

    // Validate if both fields have value
    if (glnumber) {
      validateGLNumber(
        glnumber,
        glentityName,
        setError,
        setEmpTypeDataIsChange
      );
    } else {
      setEmpTypeDataIsChange(false);
      setError("");
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.glentityId);
    setEmpTypeDataIsChange(false);
    setEdit(true);
    setCheckStatus(rowData.isActive);
    setEditRowData({ ...rowData });
    const updatedData = empNewData.map((x) => ({
      ...x,
      isActive: rowData.isActive,
      glentityId: rowData.glentityId,
      glentityName: rowData.glentityName,
      glnumber: rowData.glnumber,
      createdDate: rowData.createdDate,
      createdBy: rowData.createdBy,
    }));

    setNewData(updatedData);
  };

  //Save changes
  const handleSave = (empNewData) => {
    setOpenModalEdit(false);
    const glEntityName = empNewData[0].glentityName.trim();
    if (actionEditState) {
      UpdateGLEntity(empNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else if (
            editRowData.glnumber === empNewData[0].glnumber &&
            editRowData.glentityName === glEntityName &&
            editRowData.isActive === empNewData[0].isActive
          ) {
            toast.fire("Saving Failed", "No Changes have been made", "warning");
            setOpenModalEdit(false);
          } else {
            setNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            queryClient.invalidateQueries(["GetGLEntitys"]);
            toast.fire("Success", "GL Entity Updated Successfully", "success");
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update GL Entity", "error");
          queryClient.invalidateQueries(["GetGLEntitys"]);
          setOpenModalEdit(false);
        },
      });
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.glentityId);
    BulkDeleteGLEntity(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "GL Entities" : "GL Entity"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "GL Number",
      field: "glnumber",
      customSort: (a, b) =>
        a.glnumber && b.glnumber
          ? a.glnumber.trim().localeCompare(b.glnumber.trim())
          : a.glnumber
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.glentityId === editRowId ? (
          <div className="flex flex-col cursor-pointer">
            <TextInput
              placeholder="GL Number"
              defaultValue={rowData.glnumber}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "GLEntityType",
                  "glnumber",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
            {error && (
              <p className="text-xs text-red-500 mt-1 italic">{error}</p>
            )}
          </div>
        ) : (
          <>{rowData.glnumber}</>
        );
      },
    },
    {
      title: "GL Entity Name",
      field: "glentityName",
      customSort: (a, b) =>
        a.glentityName && b.glentityName
          ? a.glentityName.trim().localeCompare(b.glentityName.trim())
          : a.glentityName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.glentityId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="GL Entity"
              defaultValue={rowData.glentityName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "GLEntityType",
                  "glentityName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.glentityName}</>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.glentityId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.glentityId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.glentityId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.glentityId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.glentityId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },

    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.glentityId === editRowId ? (
          <div className="flex place-content-center gap-2 ">
            <SaveButton
              className={`rounded-full  lg:text-center bg-senary hover:bg-senary
               ${!empTypeDataIsChange ? "opacity-50" : "opactiy-100"}
             }`}
              disabled={!empTypeDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
                sethideColumn(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                sethideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const [glId, setGLId] = useState("");
  useEffect(() => {
    if (filterText) {
      setGlEntyFilteredData(
        data?.filter((x) =>
          x.glentityName
            ?.toLowerCase()
            .includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (glId?.includes(".")) {
      let glIds = glId.split(".");
      const glIdsArr = glIds.map((id) => Number(id));
      const filteredData = data?.filter((x) => glIdsArr.includes(x.glentityId));

      setGlEntyFilteredData(filteredData);
    } else {
      const filteredData = data?.filter((x) => x.glentityId === Number(glId));
      setGlEntyFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down w-full">
      {!actionAddState && (
        <>
          <div className="bg-white p-4 space-y-2">
            <div className="flex flex-row justify-between items-center">
              <TableFilters
                filterText={setFilterText}
                moduleDetails="GL Entity Name"
                textInputName="glentityName"
                disabledButton={disabledButton || selectedRows.length > 0}
              ></TableFilters>

              <div className="">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    buttonText="New GL Entity"
                    className={
                      selectedRows.length > 0 || actionEditState
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    onClick={() => setActionAddState(!actionAddState)}
                    disabled={disabledButton || selectedRows.length > 0}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            <div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
            </div>

            <div className="">
              <MaterialOfficeConfigTable
                columns={matColumns}
                data={
                  glEntyFilteredData?.length > 0
                    ? glEntyFilteredData
                    : data
                    ? filterText === ""
                      ? data
                      : glEntyFilteredData
                    : []
                }
                options={{
                  toolbar: false,
                  showTitle: false,
                }}
                selection={
                  !actionEditState && userPermissions.includes(deletePermission)
                }
                setOpenModal={setOpenModalDelete}
                onSelectionChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                isDeactivate={true}
                isLoading={isFetching}
              />
            </div>
          </div>
          <ConfirmBoxModal
            ModalTitle="Update GL Entity"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
              sethideColumn(true);
            }}
            onClickFunction={() => {
              handleSave(empNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate GL Entity"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </>
      )}
      {actionAddState && (
        <div className="p-4">
          <GLEntityForm />
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

export default GLEntityTable;
